import React, { Component, Fragment, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import LoginNav from './LoginNav'
import { withAuth } from './AuthContext'
import MediaQuery from 'react-responsive'
import NavLink from './Utils/NavLink'
import Cookies from 'universal-cookie'
import {
  textTranslation,
  shouldTranslateTo,
  getCurrentLanguageName,
} from '../utils/utils'
import styled from 'styled-components'
import { decode } from 'html-entities'
import { useEffect } from 'react'

import { Subtitle, Title, Button } from './Utils/CustomClasses'

const cookies = new Cookies()
const queryParams = new URLSearchParams(window.location.search)

var languageFlag = ''
if (queryParams.get('lc') !== undefined && queryParams.get('lc') !== null) {
  languageFlag = queryParams.get('lc')
} else if (cookies.get('lC') !== undefined && cookies.get('lC') !== null) {
  languageFlag = cookies.get('lC')
} else {
  languageFlag = 'en'
}

const Modal = ({ handleClose, showModal, children }) => {
  const showHideClassName = showModal
    ? 'modal-aaa aaa-display-block'
    : 'modal-aaa aaa-display-none'

  return (
    <div className={showHideClassName}>
      <section className="modal-aaa-main">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Settings
          </h5>
          <button type="button" className="close" onClick={handleClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        {children}
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </section>
    </div>
  )
}

const BannerOffer = styled.div`
  height: 100px;
  position: absolute;
  z-index: 9999999;
  width: 100vw;

  background-color: #eb5e55;
  /*background-image: url("/images/header-bk.svg");*/
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-blend-mode: overlay;

  @media screen and (max-width: 767px) {
    height: 250px;
    padding: 0 10px;
    /*background-image: url("/images/header-bk-mobile.svg");*/
  }
`

const Flex = styled.div`
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    height: 250px;
  }
`

const CustomButton = styled(Button)`
  background-color: #fff;

  a {
    color: #eb5e55;
    padding: 9px 35px;
  }
`

const TextField = styled.div`
  text-align: start;
  margin-left: 15px;
  flex-shrink: 0;

  @media screen and (max-width: 767px) {
    text-align: center;
    margin-left: 0;
    flex-basis: unset;
  }
`

const Banner = ({ translated }) => {
  return (
    <BannerOffer className="offer-banner">
      <Flex>
        <TextField>
          <Title size="28px" sizemd="28px" sizesm="28px" white>
            {translated[13]}
          </Title>
          <Subtitle
            size="23px"
            sizemd="23px"
            sizesm="18px"
            white
            marginsm="15px 0 0 0"
          >
            {translated[14]}
          </Subtitle>
        </TextField>
        <CustomButton>
          <Link
            to={
              cookies.get('gyguV') === 'B'
                ? '/gift-your-grown-up-b'
                : '/gift-your-grown-up'
            }
            dangerouslySetInnerHTML={{
              __html: `${translated[15]}`,
            }}
          ></Link>
        </CustomButton>
      </Flex>
    </BannerOffer>
  )
}

const Nav = (props) => {
  return (
    <Fragment>
      {props.showBanner ? <Banner translated={props.translated} /> : null}
      <div
        className="top-nav-nw"
        style={{ marginTop: props.showBanner && '100px' }}
      >
        <Link
          id="lnk-language"
          className="language-new"
          to="/"
          onClick={props.showModal}
        >
          <h6
            style={{
              'font-size': '16px',
              'font-weight': 'normal',
              'margin-right': '8px',
              'font-family': 'open-sans',
            }}
          >
            Language:
          </h6>
          <img
            src={'/images/languages/' + languageFlag + '.svg'}
            alt={languageFlag}
            className="flag"
          />
          <strong>{getCurrentLanguageName(languageFlag)}</strong>
        </Link>
      </div>
      <nav
        id="main-nav"
        className={`navbar navbar-expand-md navbar-light bg-faded`}
        style={{ marginTop: props.showBanner && '140px' }}
      >
        <div className="container-nav">
          <Link
            id="lnk-home"
            className="navbar-brand d-none d-md-block"
            to={'/'}
          >
            <img
              src="/images/freebird-header-logo-dark.svg"
              alt="Freebird Club"
              className="logo"
            />
          </Link>
          <ul className="navbar-nav ml-auto">
            {props.links.map((link, i) =>
              link.dataTitle == 'link-homestays' ? (
                <div key={Math.random()} className="beta-cont">
                  <NavLink
                    id="lnk-nav"
                    path={link.path}
                    text={link.text}
                    isActive={link.isActive}
                    key={link.path}
                    dataTitle={link.dataTitle}
                    className="dropdown"
                  />
                  <div className="beta-badge-inline">BETA</div>
                </div>
              ) : (
                <NavLink
                  id="lnk-nav"
                  path={link.path}
                  text={link.text}
                  isActive={link.isActive}
                  key={link.path}
                  dataTitle={link.dataTitle}
                  className="dropdown"
                />
              )
            )}
          </ul>
          <ul className="navbar-nav navbar-nav-links ml-auto">
            <LoginNav loggedIn={props.loggedIn} translated={props.translated} />
          </ul>
        </div>
      </nav>
    </Fragment>
  )
}

class AvatarMenu extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const notifications = this.props.notifications
    return (
      <Fragment>
        {notifications > 0 && (
          <div className="notification-badge">
            {notifications > 9 ? '9+' : notifications}
          </div>
        )}

        <div className="avatar-holder">
          {this.props.u !== null &&
          this.props.u.profilePhotoStatus === 'completed' ? (
            <img
              className="img-fluid"
              src={s3AwsEndpoint + '/' + this.props.u.profilePhotoO}
              onError={(e) => {
                e.target.onError = null
                e.target.src = '/images/listing/default-profile.png'
              }}
            />
          ) : (
            <img
              className="img-fluid"
              src={'/images/listing/default-profile.png'}
            />
          )}
          <span>{this.props.translated[10]}</span>
        </div>
      </Fragment>
    )
  }
}
class ResponsiveNav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  render() {
    const notifications = this.props.notifications.messages
    const { loggedIn } = this.props

    return (
      <Fragment>
        {this.props.showBanner ? (
          <Banner translated={this.props.translated} />
        ) : null}
        <div
          className="col-12 top-nav top-nax-fix"
          style={{
            position: this.props.showBanner && 'absolute',
            marginTop: this.props.showBanner && '250px',
          }}
        >
          <Link
            id="lnk-language"
            className="link-content"
            to="/"
            onClick={this.props.showModal}
          >
            <img
              src={'/images/languages/' + languageFlag + '.svg'}
              alt={languageFlag}
              className="flag"
            />
            <strong>{languageFlag}</strong>
            <img className="arrow" src="/images/arrow-down.svg" />
          </Link>
        </div>
        <nav
          className={`navbar navbar-responsive amber ${
            this.props.loggedIn ? '' : 'guest'
          }`}
          style={{ marginTop: this.props.showBanner && '275px' }}
        >
          <Link
            id="lnk-home"
            className="navbar-brand d-md-none"
            to={cookies.get('tT') == 'fb1' ? '/1020230001' : '/'}
          >
            <img
              src="/images/freebird-header-logo-dark.svg"
              alt="Freebird Club"
              style={{ width: '100px' }}
            />
          </Link>
          {!this.props.loggedIn && (
            <Link
              id="lnk-signup"
              className="btn btn-join btn-navigation d-md-none"
              to="/signup"
            >
              Join Us
            </Link>
          )}
          <div
            className="navbar-toggler collapsed"
            data-toggle="collapse"
            data-target="#navbarSupported"
            aria-controls="navbarSupported"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => this.setState({ open: !this.state.open })}
          >
            {this.props.loggedIn ? (
              <div className="flex-navbar">
                <div className="menu-container">
                  <div
                    className={`hamburguer-icon ${
                      this.state.open ? 'open' : ''
                    }`}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <a>Menu</a>
                </div>
                <AvatarMenu
                  u={this.props.u}
                  notifications={notifications}
                  translated={this.props.translated}
                />
              </div>
            ) : (
              <Fragment>
                <div
                  className={`hamburguer-icon ${this.state.open ? 'open' : ''}`}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <a>Menu</a>
              </Fragment>
            )}
          </div>
          <div className="collapse navbar-collapse" id="navbarSupported">
            <ul className="navbar-nav mr-auto">
              {this.props.authLinks
                .filter((link) => link.loggedIn == loggedIn)
                .map((link, i) => (
                  <NavLink
                    id="lnk-nav"
                    path={link.path}
                    text={link.text}
                    isActive={link.isActive}
                    key={link.path}
                    className={`dropdown ${loggedIn ? 'auth' : ''}`}
                    onClick={() => this.handleClick(i)}
                    notificationMessages={notifications}
                  />
                ))}
              {this.props.links.map((link, i) =>
                link.dataTitle == 'link-homestays' ? (
                  <div className="beta-cont-responsive">
                    <NavLink
                      id="lnk-nav"
                      path={link.path}
                      text={link.text}
                      isActive={link.isActive}
                      key={link.path}
                      dataTitle={link.dataTitle}
                      className="dropdown"
                      onClick={() => this.handleClick(i)}
                      notificationMessages={notifications}
                    />
                    <div className="beta-badge-inline">BETA</div>
                  </div>
                ) : (
                  <NavLink
                    id="lnk-nav"
                    path={link.path}
                    text={link.text}
                    isActive={link.isActive}
                    key={link.path}
                    dataTitle={link.dataTitle}
                    className="dropdown"
                    onClick={() => this.handleClick(i)}
                    notificationMessages={notifications}
                  />
                )
              )}
            </ul>
          </div>
        </nav>
      </Fragment>
    )
  }
}

const handleLanguageChange = (value) => {
  var currentUrlArr = window.location.href.split('?')
  var currentUrl = currentUrlArr[0]
  var newQueryString = ''
  if (currentUrlArr.length > 1) {
    var queryStringArr = currentUrlArr[1].split('&')
    queryStringArr.forEach(function (item) {
      if (!item.includes('lc=')) {
        newQueryString += '&' + item
      }
    })
  }
  window.location.href = currentUrl + '?lc=' + value + newQueryString
}

const Language = ({ id, label, value }) => (
  <li key={id}>
    <a
      className="lang"
      href="#"
      data-value={value}
      onClick={() => {
        handleLanguageChange(value)
      }}
    >
      <img
        alt={`${label}`}
        src={`/images/languages/${value}.svg`}
        className="flag"
      />
      {label}
    </a>
  </li>
)

const HeaderSize = styled.header`
  min-height: 90px;

  @media only screen and (width: 768px) {
    min-height: 180px;
  }

  @media only screen and (min-width: 769px) and (max-width: 991px) {
    min-height: 70px;
  }

  &.header-space {
    min-height: 190px; //BANNER

    @media only screen and (min-width: 769px) and (max-width: 991px) {
      min-height: 250px; //BANNER TABLET
    }

    @media only screen and (width: 768px) {
      min-height: 300px;
    }

    @media only screen and (max-width: 767px) {
      min-height: 300px; //BANNER MOBILE
    }
  }
`
class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navLinksData: [],
      links: null,
      authLinks: null,
      languages: [],
      currentLangName: null,
      showModal: false,
      avatarSpan: null,
    }
    this.showModal = this.showModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
  }

  componentDidMount() {
    const setNavLinks = (linkData) => {
      var navLinks = []
      if (cookies.get('tT') == 'fb1') {
        navLinks = [
          {
            path: '/how-it-works',
            text: decode(linkData[3]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-howitworks',
          },
          {
            path: '/search?seeking=locals',
            text: decode(linkData[1]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-locals',
          },
          {
            path: '/search?seeking=homestays',
            text: decode(linkData[0]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-homestays',
          },
          {
            path: '/blog',
            text: decode(linkData[4]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-blog',
          },
        ]
      } else {
        navLinks = [
          {
            path: '/how-it-works',
            text: decode(linkData[3]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-howitworks',
          },
          {
            path: '/about-us',
            text: decode(linkData[12]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-aboutus',
          },
          {
            path: '/search?seeking=locals',
            text: decode(linkData[1]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-locals',
          },
          {
            path: '/search?seeking=homestays',
            text: decode(linkData[0]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-homestays',
          },
          {
            path: '/blog',
            text: decode(linkData[4]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-blog',
          },
          {
            path: '/faq',
            text: decode(linkData[2]),
            isActive: false,
            isButton: false,
            dataTitle: 'link-faq',
          },
        ]
      }
      let authLinks = [
        {
          path: '/login',
          text: linkData[5],
          isActive: false,
          loggedIn: false,
          isButton: false,
          dataTitle: 'link-login',
        },
        {
          path: '/dashboard',
          text: linkData[7],
          isActive: false,
          loggedIn: true,
          isButton: false,
          dataTitle: 'link-dashboard',
        },
        {
          path: '/dashboard/messages',
          text: linkData[8],
          isActive: false,
          loggedIn: true,
          isButton: false,
          dataTitle: 'link-messages',
        },
        {
          path: '/logout',
          text: linkData[9],
          isActive: false,
          loggedIn: true,
          isButton: false,
          dataTitle: 'link-logout',
        },
      ]
      this.setState({
        authLinks,
        links: navLinks,
      })
    }

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setNavLinks(pageText)
          this.setState({
            navLinksData: pageText,
          })
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }
    getPageText('header', language)

    axios
      .get('/api/languages')
      .then((res) => {
        const languages = res.data.map(function (language) {
          return {
            id: language.id,
            label: language.name,
            value: language.code,
          }
        })
        if (this.state.currentLangName === null) {
          this.setState({
            currentLangName: 'French',
          })
        }
        this.setState({
          languages: languages,
        })
      })
      .catch((e) => {
        console.log(e)
      })
  }

  handleClick(i) {
    const links = this.state.links.slice()
    for (const j in links) {
      links[j].isActive = i == j
    }
    this.setState({ links: links })
  }

  showModal(e) {
    e.preventDefault()
    this.setState({ showModal: true })
  }

  hideModal() {
    this.setState({ showModal: false })
  }

  render() {
    const customStyles = {
      control: (base, state) => ({
        ...base,
        background: '#ffffff',
        color: '#8d95a6',
        height: '58px',
        fontSize: '16px',
        paddingLeft: '15px',
        width: '100%',
        marginBottom: '10px',
        outline: 'none',
        flexWrap: 'nowrap',
        border: 'none',
      }),
    }
    if (
      this.state.navLinksData.length === 0 ||
      this.state.languages.length === 0 ||
      this.state.currentLangName === null
    ) {
      return null
    }
    const notifications = this.props.auth.notifications
    const u = this.props.auth.user
    /*
        const showBanner =
            !this.props.auth.loggedIn &&
            !location.pathname.includes("gift-your-grown-up");
        */
    const showBanner = false

    return (
      <HeaderSize
        className={`${this.props.className} ${
          showBanner ? 'header-space' : ''
        }`}
      >
        {/*
                    !this.props.auth.loggedIn ?
                        <div className="offer-banner">
                            <Link className="offer-link" to="/specialoffer">
                                Amazing deal :: <span>Join for {decode(cookies.get('cS'))}5 before August 5th!<br/>Click here to learn more</span>
                            </Link>
                        </div>
                    : null
                */}
        <div
          style={{
            zIndex: 999997,
            position: 'absolute',
            height: '40px',
            width: '200px',
          }}
        >
          <Modal showModal={this.state.showModal} handleClose={this.hideModal}>
            <div>
              <h2>aaaaaaChoose your preferred language</h2>
              <div>
                <ul className="lang-list">
                  {this.state.languages.map(Language)}
                </ul>
              </div>
            </div>
          </Modal>
        </div>
        <MediaQuery minWidth={768}>
          <Nav
            loggedIn={this.props.auth.loggedIn}
            links={this.state.links}
            translated={this.state.navLinksData}
            currentLangName={this.state.currentLangName}
            showModal={this.showModal}
            showBanner={showBanner}
          />
        </MediaQuery>
        <MediaQuery maxWidth={767}>
          <ResponsiveNav
            loggedIn={this.props.auth.loggedIn}
            links={this.state.links}
            authLinks={this.state.authLinks}
            notifications={notifications}
            u={u}
            showModal={this.showModal}
            translated={this.state.navLinksData}
            showBanner={showBanner}
          />
        </MediaQuery>
        {this.props.children}
      </HeaderSize>
    )
  }
}

export default withAuth(Header)
